export function compareDistance(a, b) {
  return a.distance - b.distance;
}
